module.exports = __webpack_public_path__ + "img/bg.0cb47c2f.png";